export default "__VITE_ASSET__CajYM$NW__"